/**
 * DEFAULT_METADATA
 *
 * Single source of truth for all hardcoded fallback strings used in metadata
 * generation across the site. Update here to change any default title,
 * description, or organisation value everywhere at once.
 */
export const DEFAULT_METADATA = {
  // ── Site identity ────────────────────────────────────────────────────────────
  siteName: 'Lend',
  siteUrl: 'https://www.lend.com.au',
  websiteDescription: "Australia's #1 business loan marketplace",

  // ── Organisation ─────────────────────────────────────────────────────────────
  orgLegalName: 'Lend Capital Pty Ltd',
  orgFoundingDate: '2016',
  orgDescription:
    'Lend is an Australian business finance marketplace helping SMEs access funding from 80+ lenders using AI-powered policy matching. Fast, fully online, with no credit impact.',
  orgAddressLocality: 'Sydney',
  orgAddressRegion: 'NSW',
  orgAddressCountry: 'AU',
  orgAreaServed: 'Australia',
  orgServiceType: 'Business Finance Marketplace',
  orgLogoUrl:
    'https://s3.ap-southeast-2.amazonaws.com/files.lend.com.au/images/logos/logo_square.png',
  orgSameAs: [
    'https://au.linkedin.com/company/lend-capital',
    'https://www.reviews.io/company-reviews/store/lend-com-au',
  ],

  // ── Platform (SoftwareApplication node — carries aggregateRating/review) ──────
  platformDescription:
    "Lend's business finance marketplace matches Australian SMEs and brokers to 80+ lenders using AI-powered policy matching.",

  // ── Contact point ─────────────────────────────────────────────────────────────
  contactPointType: 'customer service',
  contactPointAreaServed: 'AU',
  contactPointLanguage: 'English',

  // ── Homepage ─────────────────────────────────────────────────────────────────
  homepageTitle: "Lend | Small Business Loans for SMEs | Australia's #1",
  homepageDescription:
    "Find your best business loan in minutes. Lend's AI matches your profile across 80+ Australian lenders instantly — no credit impact, same-day results.",

  // ── About ────────────────────────────────────────────────────────────────────
  aboutTitle: 'About Lend | Australian Business Finance Marketplace',
  aboutDescription:
    'Learn how Lend is helping Australian SMEs access business finance faster with AI-powered lender matching across 80+ lenders.',

  // ── Contact ──────────────────────────────────────────────────────────────────
  contactTitle: 'Contact Lend | Business Loan Support & Enquiries',
  contactDescription:
    "Get in touch with Lend's expert team. We help Australian businesses find the right loan from 80+ lenders. Same-day response.",

  // ── Article ──────────────────────────────────────────────────────────────────
  articleFallbackDescription:
    "Explore Australia's top small business loans. Learn how Lend helps you access funding from multiple lenders, fast.",

  // ── Resource articles ────────────────────────────────────────────────────────
  articleTitle: 'Article | Lend',
  articleDescription: 'Resource article',

  // ── Generic build-time placeholders (used when CMS is unavailable) ───────────
  genericPageTitle: 'Page | Lend',
  genericPageDescription: 'Page on Lend',
} as const;
